<template>
  <VCard
    key="restore"
    class="login-form"
  >
    <div class="logo">
      <VLogo/>
    </div>

    <header>Забыли пароль?</header>

    <VForm
      ref="form"
    >
      <div class="form">
        <VInput
          v-model="form.email"
          label="Почта"
          layout="vertical"
          type="email"
          autocomplete="email"
          required
          hide-asterisk
          @keyup.enter="onSubmit"
        />

        <FormAgreementCheckbox :form="form"/>

        <div class="actions-wrap">
          <VButton
            :disabled="isLoading"
            theme="primary"
            @click="onSubmit"
          >
            Напомнить пароль
          </VButton>

          <VButton @click="$router.push('/login')">
            Отмена
          </VButton>
        </div>

        <div class="helper-link">
          <VButton
            theme="link"
            type="button"
            @click="$router.push('/login/code')"
          >
            У меня есть код
          </VButton>
        </div>
      </div>
    </VForm>
  </VCard>
</template>

<script>
import GlobalLoader from "@/core/services/GlobalLoader/GlobalLoader";

import LoginForm from "@/pages/common/LoginPage/LoginForm";

import VLogo from "@/lib/components/VLogo/VLogo.vue";
import ValidationFormMixin from "@/mixins/validation-form-mixin";
import FormAgreementCheckbox from "@/pages/common/LoginPage/components/FormAgreementCheckbox.vue";

export default defineComponent({
  name: 'RestoreView',

  mixins: [
    ValidationFormMixin
  ],

  components: {
    VLogo,
    FormAgreementCheckbox
  },

  data() {
    return {
      form: new LoginForm(),
    };
  },

  computed: {
    isLoading() {
      return GlobalLoader.isVisible;
    },

    formValid() {
      return this.form.allAgreementsAccepted
        && this.form.email;
    }
  },

  methods: {
    async onSubmit() {
      if (this.isLoading === true || this.formValid === false) {
        return;
      }

      await this.validate();

      if (this.isValid === false) {
        return;
      }

      this.form.saveAgreementFlagsToLocalStorage();

      if (await this.$core.acl.sendPassword(this.form.email)) {
        this.$core.showNotification.success('Письмо выслано вам на почту');
        this.$router.push('/login');
      } else {
        this.$core.showNotification.error('Почта не найдена');
      }
    },
  },
});
</script>
